export default __webpack_public_path__ + "static/media/AdityaSawant.2ab9d4e7.jpg";